// TODO: Re-auth functionality is commented out until the next release
import Card from '@raydiant/raydial/components/Card';
import Page from '../../components/Page';
import PageLayout from '../../components/PageLayout/PageLayout';
import PageTitle from '../../components/PageLayout/PageTitle';
import TextField from '@raydiant/raydial/components/TextField';
import Button from '@raydiant/raydial/components/Button';
import history from '../../history';
import * as paths from '../../routes/paths';
import { useState } from 'react';
import {
  DeleteIntegrationConfirmationModal,
  Footer,
  Header,
} from './components';
import LoadingModal from '@raydiant/raydial/components/LoadingModal';
import useUpdateConnection from '../../hooks/useUpdateConnection';
import { Connection } from '@raydiant/api-client-js';
import { useToastState } from '@raydiant/raydial/components/Toast';
import useDeleteConnection from '../../hooks/useDeleteConnection';
// import Text from '@raydiant/raydial/components/Text';
// import LightspeedOAuthButton from '@raydiant/raydial/components/LightspeedOAuthButton';
// import config from '../../config';
// import SquareOAuthButton from '@raydiant/raydial/components/SquareOAuthButton';
// import { useLocation } from 'react-router-dom';

type ProductHubEditOAuthIntegrationProps = {
  connection: Connection;
};

const ProductHubEditOAuthIntegrationPage = (
  props: ProductHubEditOAuthIntegrationProps,
) => {
  const state = useToastState();
  const { connection } = props;
  const settings = connection.settings as { authId: string };
  // const connectorName = connection.connector.name;
  const [formData, setFormData] = useState({
    name: connection.name || '',
    authId: settings.authId,
  });
  // const [reAuthSuccessfull, setReAuthSuccessfull] = useState(false);
  const [
    isDeleteIntegrationConfirmationModalOpen,
    setIsDeleteIntegrationConfirmationModalOpen,
  ] = useState(false);
  const deleteConnectionQuery = useDeleteConnection();
  const { mutateAsync: deleteConnection } = deleteConnectionQuery;
  const updateConnectionQuery = useUpdateConnection();
  const { mutateAsync: updateConnection } = updateConnectionQuery;

  const isValid = formData.name.length > 0;
  const connectorDisplayName = connection.connector.displayName;
  // const location = useLocation();
  // const searchParams = new URLSearchParams(location.search);
  // const authIdQueryParam = searchParams.get('authId');
  // const nameQueryParam = searchParams.get('name');

  // const resetQueryParams = () => {
  //   const currentLocation = history.location;
  //   const pathname = currentLocation.pathname;

  //   history.replace({
  //     pathname,
  //     search: '',
  //   });
  // };

  // Handle OAuth redirects
  // useEffect(() => {
  //   resetQueryParams();

  //   if (authIdQueryParam && nameQueryParam) {
  //     setReAuthSuccessfull(true);
  //     setFormData({
  //       ...formData,
  //       name: nameQueryParam,
  //       authId: authIdQueryParam,
  //     });
  //     // Ensure query params are cleared to prevent the start of the integration wizard from reappearing

  //     state.add({
  //       title: 'Reconnected successfully',
  //       description: `${connectorDisplayName} integration has been updated`,
  //     });
  //   }
  // }, [
  //   authIdQueryParam,
  //   connectorDisplayName,
  //   connectorName,
  //   formData,
  //   nameQueryParam,
  //   state,
  // ]);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    await updateConnection({
      id: connection.id,
      params: {
        name: formData.name,
        settings: {
          authId: formData.authId,
        },
      },
    });

    state.add({
      title: 'Integration Updated',
      description: 'Integration settings have been updated successfully',
    });
    history.push(paths.integrations());
  };

  // const handleSubmitOAuthReconnect = async (
  //   e: React.FormEvent<HTMLFormElement>,
  // ) => {
  //   e.preventDefault();
  //   const connectorApiUrls: Record<string, string> = {
  //     square: `${config.squareConnectorApiUrl}/product-catalog/oauth/authorize`,
  //     lightspeed: `${config.lightspeedConnectorApiUrl}/authorization`,
  //   };

  //   const authUrl = connectorApiUrls[connectorName];
  //   const url = new URL(authUrl);

  //   const redirectUri = new URL(window.location.href);
  //   redirectUri.searchParams.set('name', formData.name);

  //   url.searchParams.set('redirect_uri', redirectUri.href);
  //   url.searchParams.set('auth_id', settings.authId);
  //   console.log(url.href);
  //   window.location.href = url.href;
  // };

  const handleDeleteIntegration = () => {
    setIsDeleteIntegrationConfirmationModalOpen(true);
  };

  const onCloseDeleteIntegrationConfirmationModal = () => {
    setIsDeleteIntegrationConfirmationModalOpen(false);
  };

  const handleOnNameChange = (name: string) => {
    setFormData({ ...formData, name });
  };

  const deleteIntegration = async () => {
    await deleteConnection(connection.id);
    setIsDeleteIntegrationConfirmationModalOpen(false);
    state.add({
      title: 'Integration Deleted',
      description: `${connection.connector.displayName} integration deleted successfully`,
    });
    history.push(paths.integrations());
  };

  return (
    <Page>
      <PageLayout
        title={<PageTitle title="Integrations" />}
        className="text-black"
      >
        <LoadingModal
          isOpen={
            updateConnectionQuery.isLoading || deleteConnectionQuery.isLoading
          }
        />
        <DeleteIntegrationConfirmationModal
          onClose={onCloseDeleteIntegrationConfirmationModal}
          isOpen={isDeleteIntegrationConfirmationModalOpen}
          onDelete={deleteIntegration}
          connectionName={connection.name}
        />
        <div className="grid grid-cols-1 lg:grid-cols-[3fr_2fr] gap-12 items-start max-w-[1200px]">
          <Card>
            <Header
              heading="Edit Integration Settings"
              subheading={`Manage ${connectorDisplayName} integration`}
            />
            <form onSubmit={handleSubmit}>
              <div className="mb-6">
                <TextField
                  label="Integration Name"
                  placeholder="Enter integration name"
                  description="This could be your restaurant or brand, eg: The Burger Barn"
                  onChange={handleOnNameChange}
                  value={formData.name}
                  aria-label="integration name"
                  autoFocus
                />
              </div>

              <Footer>
                <Button
                  size="large"
                  variant="caution"
                  className="flex-1"
                  onPress={handleDeleteIntegration}
                >
                  Delete Integration
                </Button>
                <Button
                  size="large"
                  variant="primary"
                  className="flex-1"
                  type="submit"
                  isDisabled={!isValid}
                >
                  Save
                </Button>
              </Footer>
            </form>
          </Card>
          {/* {!reAuthSuccessfull && (
            <Card>
              <Header
                heading={`Reconnect with ${connectorDisplayName}`}
                subheading="Re-authenticate your account"
              />
              <form
                onSubmit={handleSubmitOAuthReconnect}
                className="px-4 flex flex-col"
              >
                <Text className="mb-4">
                  Your {connectorDisplayName} account needs to be
                  re-authenticated. Please log into the same{' '}
                  {connectorDisplayName} account that was used to create the{' '}
                  {formData.name} integration.
                </Text>
                <div className="mb-4 flex flex-col">
                  {connectorName === 'square' && (
                    <SquareOAuthButton type="submit" />
                  )}
                  {connectorName === 'lightspeed' && (
                    <LightspeedOAuthButton type="submit" />
                  )}
                </div>
              </form>
            </Card>
          )} */}
        </div>
      </PageLayout>
    </Page>
  );
};

export default ProductHubEditOAuthIntegrationPage;
